var _rect, _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecruitementexecutionserviceimage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 172,
    viewBox: "0 0 182 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 122.136,
    y: 107.384,
    width: 76.9805,
    height: 20.3623,
    rx: 10.1812,
    transform: "rotate(39.2062 122.136 107.384)",
    fill: "url(#paint0_radial_3017_427)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75.7139,
    cy: 74.9628,
    r: 74.9267,
    fill: "url(#paint1_radial_3017_427)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3017_427)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75.7139,
    cy: 74.9626,
    r: 61.7243,
    fill: "url(#paint2_radial_3017_427)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3017_427)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75.7139,
    cy: 74.9625,
    r: 20.6434,
    stroke: "white",
    strokeWidth: 0.669515
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 75.7139,
    cy: 74.9625,
    r: 20.9781,
    fill: "url(#paint3_linear_3017_427)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3017_427)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4224 85.7384C62.3549 79.6289 68.5994 75.4108 75.8291 75.4108C83.0588 75.4108 89.3034 79.629 92.2359 85.7385C88.4152 90.5931 82.4862 93.7105 75.8292 93.7105C69.172 93.7105 63.243 90.5931 59.4224 85.7384ZM82.636 65.9249C82.636 69.6842 79.5885 72.7316 75.8292 72.7316C72.07 72.7316 69.0225 69.6842 69.0225 65.9249C69.0225 62.1656 72.07 59.1182 75.8292 59.1182C79.5885 59.1182 82.636 62.1656 82.636 65.9249Z",
    fill: "url(#paint4_linear_3017_427)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_3017_427)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.7333,
    cy: 57.6049,
    r: 8.46233,
    stroke: "white",
    strokeWidth: 0.274454
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 38.7333,
    cy: 57.6049,
    r: 8.59956,
    fill: "url(#paint5_linear_3017_427)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3017_427)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0551 62.0224C33.2572 59.5179 35.817 57.7887 38.7807 57.7887C41.7444 57.7887 44.3043 59.5179 45.5064 62.0225C43.9402 64.0126 41.5097 65.2905 38.7808 65.2905C36.0518 65.2905 33.6213 64.0125 32.0551 62.0224ZM41.571 53.9001C41.571 55.4412 40.3218 56.6904 38.7808 56.6904C37.2397 56.6904 35.9905 55.4412 35.9905 53.9001C35.9905 52.3591 37.2397 51.1099 38.7808 51.1099C40.3218 51.1099 41.571 52.3591 41.571 53.9001Z",
    fill: "url(#paint6_linear_3017_427)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_3017_427)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.9525,
    cy: 107.09,
    r: 13.1668,
    stroke: "white",
    strokeWidth: 0.427032
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 33.9525,
    cy: 107.09,
    r: 13.3803,
    fill: "url(#paint7_linear_3017_427)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3017_427)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5614 113.963C25.4318 110.066 29.4147 107.376 34.0261 107.376C38.6375 107.376 42.6206 110.066 44.4909 113.963C42.054 117.06 38.2723 119.048 34.0262 119.048C29.78 119.048 25.9983 117.06 23.5614 113.963ZM38.3677 101.325C38.3677 103.723 36.424 105.667 34.0262 105.667C31.6285 105.667 29.6847 103.723 29.6847 101.325C29.6847 98.9276 31.6285 96.9839 34.0262 96.9839C36.424 96.9839 38.3677 98.9276 38.3677 101.325Z",
    fill: "url(#paint8_linear_3017_427)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_3017_427)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110.863,
    cy: 116.472,
    r: 17.3941,
    stroke: "white",
    strokeWidth: 0.564133
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 110.863,
    cy: 116.472,
    r: 17.6762,
    fill: "url(#paint9_linear_3017_427)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_3017_427)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1361 125.551C99.607 120.403 104.869 116.849 110.961 116.849C117.053 116.849 122.314 120.403 124.785 125.551C121.566 129.642 116.57 132.269 110.961 132.269C105.351 132.269 100.355 129.642 97.1361 125.551ZM116.696 108.856C116.696 112.024 114.128 114.591 110.961 114.591C107.793 114.591 105.225 112.024 105.225 108.856C105.225 105.688 107.793 103.121 110.961 103.121C114.128 103.121 116.696 105.688 116.696 108.856Z",
    fill: "url(#paint10_linear_3017_427)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_3017_427)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125.343,
    cy: 45.293,
    r: 12.1156,
    stroke: "white",
    strokeWidth: 0.392938
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 125.343,
    cy: 45.293,
    r: 12.3121,
    fill: "url(#paint11_linear_3017_427)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_3017_427)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.781 51.6171C117.502 48.0313 121.167 45.5555 125.411 45.5555C129.654 45.5555 133.319 48.0313 135.04 51.6173C132.798 54.4666 129.318 56.2962 125.411 56.2962C121.503 56.2962 118.024 54.4665 115.781 51.6171ZM129.405 39.988C129.405 42.1943 127.617 43.9829 125.411 43.9829C123.204 43.9829 121.416 42.1943 121.416 39.988C121.416 37.7817 123.204 35.9932 125.411 35.9932C127.617 35.9932 129.405 37.7817 129.405 39.988Z",
    fill: "url(#paint12_linear_3017_427)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3017_427",
    x: 50.2723,
    y: 49.5209,
    width: 50.8832,
    height: 50.8829,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23172,
    result: "effect1_foregroundBlur_3017_427"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3017_427",
    x: 28.3041,
    y: 47.1757,
    width: 20.8585,
    height: 20.8586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.914847,
    result: "effect1_foregroundBlur_3017_427"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3017_427",
    x: 17.7253,
    y: 90.8631,
    width: 32.4545,
    height: 32.4545,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.42344,
    result: "effect1_foregroundBlur_3017_427"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3017_427",
    x: 89.4264,
    y: 95.0345,
    width: 42.8741,
    height: 42.8743,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.88044,
    result: "effect1_foregroundBlur_3017_427"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3017_427",
    x: 110.411,
    y: 30.3614,
    width: 29.8633,
    height: 29.8632,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.30979,
    result: "effect1_foregroundBlur_3017_427"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3017_427",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.227 117.484) rotate(0.246968) scale(76.2 878.892)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#558CF9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7C4FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3017_427",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.7139 74.9628) rotate(90) scale(74.9267)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3C1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26334B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3017_427",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.7139 74.9626) rotate(90) scale(61.7243)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C4FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#558CF9",
    stopOpacity: 0.41
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3017_427",
    x1: 61.4309,
    y1: 59.6753,
    x2: 89.6621,
    y2: 92.9279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1898,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3017_427",
    x1: 75.8291,
    y1: 59.1182,
    x2: 75.8291,
    y2: 93.7105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3017_427",
    x1: 32.8783,
    y1: 51.3382,
    x2: 44.4511,
    y2: 64.9694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1898,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3017_427",
    x1: 38.7807,
    y1: 51.1099,
    x2: 38.7807,
    y2: 65.2904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3017_427",
    x1: 24.8425,
    y1: 97.3397,
    x2: 42.849,
    y2: 118.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1898,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3017_427",
    x1: 34.0261,
    y1: 96.9839,
    x2: 34.0261,
    y2: 119.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3017_427",
    x1: 98.8286,
    y1: 103.591,
    x2: 122.616,
    y2: 131.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1898,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3017_427",
    x1: 110.961,
    y1: 103.121,
    x2: 110.961,
    y2: 132.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3017_427",
    x1: 116.96,
    y1: 36.3209,
    x2: 133.529,
    y2: 55.8368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1898,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3017_427",
    x1: 125.411,
    y1: 35.9932,
    x2: 125.411,
    y2: 56.2962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3017_427"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.9896,
    y: 13.2383,
    width: 123.449,
    height: 123.449,
    rx: 61.7243,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3017_427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.4758,
    height: 34.5916,
    fill: "white",
    transform: "translate(59.4224 59.1182)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3017_427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7227,
    height: 14.1801,
    fill: "white",
    transform: "translate(32.0551 51.1099)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3017_427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.3516,
    height: 22.0633,
    fill: "white",
    transform: "translate(23.5614 96.9839)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3017_427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.2067,
    height: 29.1469,
    fill: "white",
    transform: "translate(97.1361 103.121)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_3017_427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.6469,
    height: 20.3018,
    fill: "white",
    transform: "translate(115.781 35.9932)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitementexecutionserviceimage);
export default __webpack_public_path__ + "static/media/Recruitementexecutionserviceimage.68abd76a7f3053da1507269f5ac36f4e.svg";
export { ForwardRef as ReactComponent };